import * as React from 'react';

export interface CheckboxProps {
	onChange: (e: any) => void;
	id: string;
	checked: boolean;
	name?: string;
	noFloat?: boolean;
	disabled?: boolean;
}

export const Checkbox: React.SFC<CheckboxProps> = (props) => {
	let classes = 'am_checkbox' + (props.noFloat ? ' am_cbinner' : ' float-right');
	let num = Math.floor(Math.random() * 1000000);
	return(
		<div className={classes}>
			<input onChange={props.onChange} name={props.name} type="checkbox" id={'checkbox' + props.id + num} defaultChecked={props.checked} disabled={props.disabled}/>
			<label htmlFor={'checkbox' + props.id + num}/>
		</div>
	);
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/checkbox.tsx